import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/ArrowBack';

class ArrowBackIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default ArrowBackIcon;
